import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticatorService {

  // private readonly API_URL = environment.AUT;
  private readonly URL = environment.URL

  constructor(private readonly http: HttpClient) { }

  // ======================================================
  // 🧩 CONFIGURACIÓN 2FA (para activar/desactivar en perfil)
  // ======================================================

  /** Genera el QR y el secret del usuario */
  generate2FA(username: string) {
    return this.http.post(`${this.URL}generate`, { username });
  }

  /** Verifica el código 2FA al configurar por primera vez */
  verify2FA(username: string, token: string, secret: string) {
    return this.http.post(`${this.URL}verify`, { username, codigo: token, secret });
  }

  /** Desactiva el 2FA de un usuario */
  disable2FA(username: string) {
    return this.http.post(`${this.URL}disable`, { username });
  }

  // ======================================================
  // 🔐 LOGIN 2FA (cuando el backend requiere verificar código)
  // ======================================================

  /** Verifica el código 2FA durante el login */
  verifyLogin2FA(username: string, codigo2FA: string) {
    return this.http.post(`${this.URL}verify-2fa`, { username, codigo2FA });
  }

  // ======================================================
  // ⚙️ Otros (si quieres mantener compatibilidad)
  // ======================================================

  /** Login con 2FA (método antiguo, ya no necesario si usas verifyLogin2FA) */
  loginWith2FA(username: string, token: string) {
    return this.http.post(`${this.URL}login`, { username, token });
  }

  get2FAStatus(username: string) {
    return this.http.get(`${this.URL}status/${username}`);
  }

}
